var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Modal',{attrs:{"footer-hide":""},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('div',{attrs:{"id":"login-con"}})]),_vm._v(" "),_c('BindPhone',{ref:"bindPhone",on:{"success":function($event){return _vm.$emit('success')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }